import { render, staticRenderFns } from "./sprite-icon.vue?vue&type=template&id=6ca5444b&"
import script from "./sprite-icon.vue?vue&type=script&lang=js&"
export * from "./sprite-icon.vue?vue&type=script&lang=js&"
import style0 from "./sprite-icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./sprite-icon.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca5444b')) {
      api.createRecord('6ca5444b', component.options)
    } else {
      api.reload('6ca5444b', component.options)
    }
    module.hot.accept("./sprite-icon.vue?vue&type=template&id=6ca5444b&", function () {
      api.rerender('6ca5444b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/sprite-icon/sprite-icon.vue"
export default component.exports